import { useMemo } from 'react'
import { Combobox } from '@/components/combobox'
import { useCampaignOptions } from '../api'
import { CampaignSwatch } from './campaign-badges'

/** Searchable campaign picker; `null` = no campaign. */
export function CampaignSelect({
  value,
  onChange,
  placeholder = 'No campaign',
  disabled,
  id,
  'aria-invalid': ariaInvalid,
  'aria-describedby': ariaDescribedBy,
}: {
  value: string | null
  onChange: (value: string | null) => void
  placeholder?: string
  disabled?: boolean
  id?: string
  'aria-invalid'?: boolean
  'aria-describedby'?: string
}) {
  const campaigns = useCampaignOptions()
  const options = useMemo(
    () =>
      (campaigns.data ?? []).map((c) => ({
        value: c.id,
        label: c.name,
        hint: c.status === 'active' ? (c.code ?? undefined) : c.status,
        prefix: <CampaignSwatch color={c.color} className="size-2.5" />,
        keywords: [c.code ?? '', c.advertiser ?? ''],
      })),
    [campaigns.data],
  )
  const withCurrent = value && !options.some((o) => o.value === value) ? [{ value, label: campaigns.isPending ? 'Loading…' : 'Unknown campaign' }, ...options] : options
  return (
    <Combobox
      id={id}
      value={value}
      onChange={onChange}
      options={withCurrent}
      placeholder={placeholder}
      searchPlaceholder="Search campaigns…"
      emptyText={campaigns.isPending ? 'Loading…' : 'No campaigns yet'}
      disabled={disabled}
      allowClear
      aria-invalid={ariaInvalid}
      aria-describedby={ariaDescribedBy}
    />
  )
}
